<ga-invites [invitationType]="invitationTypeEnum.EMPLOYEE"></ga-invites>
